import type { ReactNode } from 'react';

import { Sidebar } from './Sidebar';

/**
 * El armazón: lateral fija a partir de `lg`, barra inferior por debajo.
 *
 * Las dos navegaciones **coexisten** en el árbol y se esconden por CSS, en vez
 * de montarse según el ancho medido en JavaScript. Es a propósito: medir el
 * ancho obliga a decidir algo en el primer pintado, y en una PWA que arranca
 * desde caché eso se ve como un salto —la barra inferior aparece y desaparece—.
 * Con CSS el navegador ya sabe cuál enseñar antes de pintar nada.
 *
 * El coste es que los dos juegos de enlaces están en el DOM a la vez. Para
 * lectores de pantalla eso sería un duplicado, así que la que está oculta lo
 * está con `hidden`, que sí los saca del árbol de accesibilidad — no con
 * opacidad ni con posición fuera de pantalla.
 */
export function AppShell({
  children,
  bottomNav,
}: {
  children: ReactNode;
  bottomNav: ReactNode;
}) {
  return (
    <>
      <Sidebar />
      {/* El desplazamiento por la lateral va en el contenedor y no en `body`
          para que los elementos fijos de dentro —cabeceras pegajosas, paneles—
          se posicionen respecto a este hueco y no respecto a la ventana.

          El hueco de la barra inferior no se reserva aquí: lo publica
          `--nav-inferior` en `:root` (ver `styles/globals.css`), porque también
          lo necesitan cosas que se montan fuera de este armazón. */}
      <div className="lg:pl-60">
        {children}
        <div className="lg:hidden">{bottomNav}</div>
      </div>
    </>
  );
}
